import React from 'react';
//import PropTypes from 'prop-types'
import "./Checkbox.css"

export default function CheckBox(props: any){
    //<input type="checkbox" name={props.name} label={props.label} value={props.value} checked={props.checked} onChange={props.onChange}></input>
    return (
        <>
            {/* <input  type="checkbox" name={props.name} label={props.label} value={props.value} checked={props.checked} onChange={props.onChange}></input>
            <label className="checkbox">&nbsp;{props.label}</label> */}
            <label className="checkbox">
                <input type="checkbox" name={props.name} value={props.value} checked={props.checked} onChange={props.onChange}></input>
                <span className="checkbox-label">&nbsp;{props.label}</span>
            </label>
        </>
    )
}